import { FC, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { ResponsiveWrapper } from 'components/styled/Wrapper';
import { NavButton } from 'components/styled/Button';
import Text from 'components/styled/Text';
import { Box, Flex } from 'components/styled';

import { useLoggedInUser } from 'api';

import { isAuthPath } from 'auth/routes';

import { usePageTitle } from 'hooks/seoHooks';

import PageNotFoundImage from './NotFoundImage';

const NotFound: FC = () => {
	const { t } = useTranslation('modules/not_found/');

	const { pathname } = useLocation();
	const { goBack, push } = useHistory();

	// Page title
	usePageTitle(t('title'));

	const token = useLoggedInUser();
	useEffect(() => {
		if (!token && isAuthPath(pathname)) {
			push({ pathname: '/login', state: { redirect: pathname } });
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<ResponsiveWrapper>
			<Flex flexDirection="column" width={1}>
				<Box width={1}>
					<Text
						color="text"
						fontSize="xl"
						fontWeight="bold"
						mt={5}
						mb={4}
						as="h2"
					>
						{t('title')} (404)
					</Text>
					<Text>
						{t('page')}{' '}
						<Text as="span" fontWeight="bold">
							{pathname}
						</Text>{' '}
						{t('not_found')}.
					</Text>

					<NavButton variant="primary" mt={3} onClick={goBack}>
						{t('back')}
					</NavButton>
				</Box>
				<Box alignSelf="flex-end">
					<PageNotFoundImage />
				</Box>
			</Flex>
		</ResponsiveWrapper>
	);
};

export default NotFound;
